import { createFileRoute } from '@tanstack/react-router'
import { CapabilityPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/cloud-engineering')({
  head: ({ params }) => localizedPageHead('cloudEngineering', params.locale),
  component: () => <CapabilityPage kind="cloudEngineering" />,
})
